import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const QaIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      {...props}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.58496 13.2043C3.58496 10.5208 5.7609 8.34521 8.44527 8.34521H18.4663C21.1497 8.34521 23.3254 10.5209 23.3254 13.2043V20.051C23.3254 22.7353 21.1498 24.9113 18.4663 24.9113H17.4078C17.095 24.9113 16.7965 25.0348 16.5761 25.2553L15.1689 26.6625C14.2223 27.609 12.688 27.609 11.7415 26.6625L10.3343 25.2553C10.1139 25.0348 9.8153 24.9113 9.50254 24.9113H8.44527C5.76069 24.9113 3.58496 22.7356 3.58496 20.051V13.2043ZM8.44527 10.2652C6.82088 10.2652 5.50496 11.5815 5.50496 13.2043V20.051C5.50496 21.6752 6.82108 22.9913 8.44527 22.9913H9.50254C10.323 22.9913 11.1104 23.3161 11.6919 23.8977L13.0991 25.3048C13.2958 25.5015 13.6146 25.5015 13.8112 25.3048L15.2184 23.8977C15.7999 23.3161 16.5874 22.9913 17.4078 22.9913H18.4663C20.089 22.9913 21.4054 21.6754 21.4054 20.051V13.2043C21.4054 11.5813 20.0892 10.2652 18.4663 10.2652H8.44527Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.669 5.37508C12.0369 5.37508 10.7251 6.68925 10.7251 8.30916V9.30541C10.7251 9.83561 10.2952 10.2654 9.76505 10.2654C9.23485 10.2654 8.80505 9.83561 8.80505 9.30541V8.30916C8.80505 5.62528 10.9801 3.45508 13.669 3.45508H23.6902C26.3718 3.45508 28.5455 5.62667 28.5455 8.30916V15.1571C28.5455 17.847 26.3732 20.0199 23.6902 20.0199H22.6329C22.6036 20.0199 22.5746 20.0227 22.4789 20.0321L22.458 20.0341C21.9303 20.0855 21.4609 19.6992 21.4096 19.1715C21.3583 18.6438 21.7446 18.1744 22.2722 18.1231C22.28 18.1223 22.2887 18.1214 22.2984 18.1205C22.3727 18.113 22.5019 18.0999 22.6329 18.0999H23.6902C25.3108 18.0999 26.6255 16.7886 26.6255 15.1571V8.30916C26.6255 6.68786 25.3122 5.37508 23.6902 5.37508H13.669Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9351 16.8144C14.9351 16.0834 15.5274 15.4902 16.2591 15.4902C16.99 15.4902 17.5834 16.0826 17.5834 16.8144C17.5834 17.546 16.99 18.1386 16.2591 18.1386C15.5274 18.1386 14.9351 17.5453 14.9351 16.8144Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9375 16.8144C8.9375 16.0834 9.52995 15.4902 10.2616 15.4902C10.9924 15.4902 11.5858 16.0826 11.5858 16.8144C11.5858 17.546 10.9924 18.1386 10.2616 18.1386C9.52995 18.1386 8.9375 17.5453 8.9375 16.8144Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default QaIcon;
